/**
 * Zapas (px) nad i pod obróconą etykietą zwiniętego paska. Etykieta jest centrowana w pionie,
 * więc zapas jest symetryczny; od dołu musi pomieścić chevron (.popup-bar-toggle: padding 14 px
 * + ikona 16 px) z oddechem, żeby tekst na niego nie wjeżdżał.
 */
export const COLLAPSED_TAB_LABEL_CLEARANCE = 40

/**
 * Wysokość ZWINIĘTEGO paska panelu wysuwanego w px (przed skalą ramki) albo null = bez
 * przycinania (ramka ma wysokość treści, jak po rozwinięciu).
 *
 * Zwinięty panel pokazuje sam pasek, a ten rozciągał się na wysokość całej treści oferty —
 * na telefonie ~380 px czarnego pasa na kartach produktów (Asana 1219036947001658). Pasek ma
 * mieścić tylko etykietę („Rabaty do -24%") i chevron.
 *
 * Wysokość jest zawsze PARZYSTA: ramka jest centrowana przez translateY(-50%), więc przy
 * nieparzystej ląduje na pół piksela i tło ramki prześwituje kreską nad paskiem (DPR 1).
 *
 * @param labelLength długość etykiety przed obrotem (offsetWidth), 0 = jeszcze niezmierzona
 * @param maxHeight   dostępna wysokość (viewport minus marginesy ramki)
 */
export function collapsedTabHeight(labelLength: number, maxHeight: number): number | null {
  if (!Number.isFinite(labelLength) || labelLength <= 0) return null
  const height = Math.ceil(labelLength) + COLLAPSED_TAB_LABEL_CLEARANCE * 2
  const limit = Math.max(2, Math.floor(maxHeight))
  const capped = Math.min(height, limit)
  return capped % 2 === 0 ? capped : capped + (capped < limit ? 1 : -1)
}
